export default {
  height: 600,
  headerHeight: 48,
  previewWidth: 280,
  dialogWidth: 600,
}
